export default __webpack_public_path__ + "static/media/fitness.f1f71ba0.jpg";